import type { SpaceScale } from './types';

export const BRAVEMOVE_SPACE: SpaceScale = [0, 4, 8, 12, 16, 24, 32, 48, 64, 96];
